export default "__VITE_ASSET__CZuZbFNk__"